import { useEffect } from "react"
export default function useAppSetting() {
  useEffect(() => {
    const handleWheel = () => {
      const active = document.activeElement
      if (active && active.type === "number") {
        active.blur()
      }
    }

    const handleKeyDown = (e) => {
      const active = document.activeElement
      if (active && active.type === "number") {
        const invalidKeys = ["e", "E"]
        if (invalidKeys.includes(e.key)) {
          e.preventDefault()
        }
      }
    }
    window.addEventListener("wheel", handleWheel, { passive: false })
    window.addEventListener("keydown", handleKeyDown)

    return () => {
      window.removeEventListener("wheel", handleWheel)
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [])
}
